// Site navigation: condensed state on scroll, mobile menu toggle
(function () {
  function init() {
    var nav = document.querySelector(".mr-nav");
    if (!nav) return;
    var toggle = nav.querySelector(".mr-nav-toggle");
    var ticking = false;

    function update() {
      nav.classList.toggle("mr-nav--scrolled", window.scrollY > 80);
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();

    if (!toggle) return;

    function setOpen(open) {
      nav.classList.toggle("mr-nav--open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    }

    toggle.addEventListener("click", function () {
      setOpen(!nav.classList.contains("mr-nav--open"));
    });

    nav.addEventListener("click", function (e) {
      if (e.target.closest(".mr-nav-link")) setOpen(false);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.classList.contains("mr-nav--open")) {
        setOpen(false);
        toggle.focus();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 767) setOpen(false);
    }, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
